var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundBlur(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 703,
    height: 779,
    viewBox: "0 0 703 779",
    fill: "none",
    className: "blurbg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "plus-lighter"
    },
    opacity: 0.7,
    filter: "url(#filter0_f_3348_34490)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M421.347 87.8808C571.869 186.505 570.437 282.03 550.906 317.465C512.95 387.593 552.849 513.099 637.959 532.301C723.068 551.502 853.621 546.772 898.085 435.736C942.548 324.701 858.416 206.152 749.434 1.05615C640.452 -204.039 711.53 -240.495 661.772 -361.27C612.015 -482.045 296.349 -503.752 249.944 -361.27C203.54 -218.788 233.196 -35.3991 421.347 87.8808Z",
    fill: "url(#paint0_linear_3348_34490)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M421.347 87.8808C571.869 186.505 570.437 282.03 550.906 317.465C512.95 387.593 552.849 513.099 637.959 532.301C723.068 551.502 853.621 546.772 898.085 435.736C942.548 324.701 858.416 206.152 749.434 1.05615C640.452 -204.039 711.53 -240.495 661.772 -361.27C612.015 -482.045 296.349 -503.752 249.944 -361.27C203.54 -218.788 233.196 -35.3991 421.347 87.8808Z",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_3348_34490",
    x: -19.9004,
    y: -710.648,
    width: 1180.63,
    height: 1502.14,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_3348_34490"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3348_34490",
    x1: 158.989,
    y1: -257.221,
    x2: 827.356,
    y2: -236.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E42DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0001,
    stopColor: "#5BB099"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.336268,
    stopColor: "#67D2E9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.632216,
    stopColor: "#3D78D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81533,
    stopColor: "#212477"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundBlur);
export default __webpack_public_path__ + "static/media/backgroundBlur.2923360e4256c40a42eddd94fe0d9b4a.svg";
export { ForwardRef as ReactComponent };